export const normalizeModulePath = (path = '') => {
  if (!path) return '/';
  return path.startsWith('/') ? path : `/${path}`;
};

export const getModuleDisplayName = (name = '') =>
  name === 'Vehicle/Fleet Claims' ? 'Vehicle Damage Claims' : name;

export const getSubModuleDisplayName = (name = '') =>
  /^(submited|submitted)\s+forms?$/i.test(String(name).trim())
    ? 'Claims Reported by Location'
    : name;

export const buildMenuModules = (apiModules = [], getIcon) =>
  (Array.isArray(apiModules) ? apiModules : []).map((moduleItem) => {
    const submenu = Array.isArray(moduleItem?.sub_module)
      ? moduleItem.sub_module.map((subModule) => {
          const originalName = subModule?.sub_name || subModule?.name || subModule?.routing || 'Untitled';
          return {
            name: getSubModuleDisplayName(originalName),
            icon: getIcon?.(originalName, subModule?.routing),
            routing: normalizeModulePath(subModule?.routing),
            accessKey: `${moduleItem?.name || ''} / ${originalName}`,
            legacyAccessKey: subModule?.sub_name || subModule?.name || '',
          };
        })
      : [];

    return {
      name: getModuleDisplayName(moduleItem?.name || moduleItem?.routing || 'Untitled'),
      icon: getIcon?.(moduleItem?.name, moduleItem?.routing),
      routing: normalizeModulePath(moduleItem?.routing),
      submenu,
      accessKey: moduleItem?.name || '',
    };
  });

export const buildPermissionModuleNames = (apiModules = []) => {
  const names = [];

  (Array.isArray(apiModules) ? apiModules : []).forEach((moduleItem) => {
    if (moduleItem?.name) {
      names.push(moduleItem.name);
    }

    if (Array.isArray(moduleItem?.sub_module)) {
      moduleItem.sub_module.forEach((subModule) => {
        const subName = subModule?.sub_name || subModule?.name;
        if (subName) {
          names.push(subName);
        }
      });
    }
  });

  return [...new Set(names)];
};
